export default {"src":"/_next/static/media/icon_more_trophies.11b2f326.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};